<template>
  <div>
    <table class="table table-success table-striped">
      <thead class="table-dark">
        <tr>
          <th scope="col">No</th>
          <th scope="col">Name</th>
          <th scope="col">Status</th>
          <th scope="col">Description</th>
          <th scope="col">Price</th>
          <th scope="col">Preview</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
        <RowTable
        @getFoodDetail="getFoodDetail"
        @toEdit="goToFormEdit"
        ><RowTable/>
    </table>
  </div>
</template>

<script>
import RowTable from "./TableRow.vue";
import axios from "../apis/server";

export default {
  name: "foodTable",
  components: {
    RowTable,
  },
  methods: {
    getFoodDetail(food) {
      this.$emit("getDetailFood", food);
    },
    goToFormEdit(food) {
      this.$emit("toEdit", food);
    },
  },
};
</script>



<style>
</style>